import {Component, OnInit, ViewChild} from '@angular/core';
import {
  ParcelStrategyDirective
} from "../../legal-case-shared/legal-case-post-parcels/create-legal-case-parcel/strategy/parcel-strategy.directive";
import {ISimpleSelectableDataList} from "../../model/interface/simple-selectable-data.model.interface";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {PostService} from "../../../core/services/post.service";
import {SnackBarService} from "../../../core/services/snack-bar.service";
import {
  ParcelCreateComponentResolverService
} from "../../legal-case-shared/legal-case-post-parcels/create-legal-case-parcel/strategy/parcel-create-component-resolver.service";
import {IImportParcel, IPostParcel} from "../../model/interface/post-parcel.model.interface";
import {map, tap} from "rxjs/operators";
import {DictionaryPosition} from "../../model/dictionary.model";
import {Observable} from "rxjs";
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-import-post',
  templateUrl: './import-post.component.html',
  styleUrls: ['./import-post.component.scss']
})
export class ImportPostComponent implements OnInit {
  @ViewChild(ParcelStrategyDirective, {static: true}) strategyHost!: ParcelStrategyDirective;
  contentTypes: ISimpleSelectableDataList;
  types: ISimpleSelectableDataList;
  newParcelForm: FormGroup;

  private contentTypeId: number;

  constructor(private _formBuilder: FormBuilder,
              private _postService: PostService,
              private _snackBarService: SnackBarService,
              private _strategyService: ParcelCreateComponentResolverService,
              private _dialogRef: MatDialogRef<ImportPostComponent>) {
    this._createForm();
    this._fetchParcelContentTypes();
    this._fetchParcelTypes();
  }

  ngOnInit(): void {
    this.newParcelForm.valueChanges.subscribe()
  }

  createParcel() {
    const payload = this._createCreateParcelPayload();
    const request = this._createCreateParcelRequest(payload);
    return this._handleCreateParcelRequest(request);
  }

  private _createForm() {
    this.newParcelForm = this._formBuilder.group({
      file: [null, Validators.required],
      typeId: [null, Validators.required],
      contentTypeId: [null, Validators.required],
      attachRodo: [false, Validators.required]
    });
  }

  private _fetchParcelContentTypes() {
    const request = this._createFetchParcelContentTypesRequest();
    this._handleFetchParcelContentTypes(request);
    return request;
  }

  private _fetchParcelTypes() {
    const request = this._createFetchParcelTypesRequest();
    this._handleFetchParcelTypes(request);
    return request;
  }

  private _createCreateParcelPayload(): IImportParcel {
    return {
      file: this.newParcelForm.value.file,
      content: this._strategyService.getSubFormValue(),
      typeId: this.newParcelForm.value.typeId,
      attachRodo: this.newParcelForm.value.attachRodo
    } as IImportParcel;
  }

  private _createCreateParcelRequest(payload: IImportParcel) {
    return this._postService.importParcelsToCreate(payload).pipe(
      tap(_ => this._snackBarService.display(DictionaryPosition.OK))
    );
  }

  private _createFetchParcelContentTypesRequest() {
    return this._postService.fetchAllParcelContentTypes()
      .pipe(
        map(data => data.toSimpleSelectableDataList())
      );
  }

  private _createFetchParcelTypesRequest() {
    return this._postService.fetchAllParcelTypes()
      .pipe(
        map(data => data.toSimpleSelectableDataList())
      );
  }

  private _handleFetchParcelContentTypes(request: Observable<ISimpleSelectableDataList>) {
    return request.subscribe(data => this.contentTypes = data);
  }

  private _handleFetchParcelTypes(request: Observable<ISimpleSelectableDataList>) {
    return request.subscribe(data => this.types = data);
  }

  private _handleCreateParcelRequest(request: Observable<IPostParcel>) {
    return request.subscribe(_ => {
      this._strategyService.reset(this.strategyHost.viewContainerRef);
      this._dialogRef.close(true)
    });
  }

  getStrategyInputs(eventType: string) {
    switch (eventType) {
      case 'DEMAND_FOR_PAYMENT':
        return {
          type: this.selectedType.enum,
          legalCaseInput: null
        }
      default:
        return {
          type: this.selectedType.enum,
          legalCaseInput: null
        }
    }
  }

  onTypeSelected(contentTypeId: any) {
    if(contentTypeId !== null && this.contentTypes) {
      this.contentTypeId = contentTypeId
      const type = this.selectedType;
      if (type) {
        const inputs = this.getStrategyInputs(type.enum);
        this._strategyService.loadStrategy(type.enum, this.strategyHost.viewContainerRef, inputs);
      }
    }
  }

  get valid() {
    return this.newParcelForm.valid && this._strategyService.isSubFormValid();
  }

  get selectedType() {
    return this.contentTypes.data.find(type => type.value === this.contentTypeId)
  }
}
